import { Paper, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { FAILURE_REASON_LABEL } from 'common/components/PrintResultSummary';

/**
 * POM-6010 / POM-6121 — the rows a commit refused.
 *
 * Extracted from BulkLotNdcReviewDialog when POM-6121 gave the commit a new way to refuse one row
 * while its siblings succeed: a hand-recorded claim against an NDC core cannot resolve is rejected
 * per row, so this panel is where the operator finds out which one and why.
 *
 * A reason with no entry in FAILURE_REASON_LABEL renders as its raw code, which is the regression
 * QA re-opened POM-5933 for — so every new core refusal reason needs a label there.
 */
const BulkLotNdcRefusedPanel = ({ refused }) => {
  if (refused.length === 0) return null;

  return (
    <Paper variant='outlined' sx={{ mt: 2, p: 2 }}>
      <Typography variant='subtitle2' gutterBottom>
        {`${refused.length} item(s) kept their original lot`}
      </Typography>
      {refused.map((row) => (
        <Typography key={row.requestLineItemId} variant='body2' color='text.secondary'>
          {`${row.requestLineItemId} — ${
            FAILURE_REASON_LABEL[row.reason] ?? row.reason ?? 'Refused'
          }`}
        </Typography>
      ))}
    </Paper>
  );
};

BulkLotNdcRefusedPanel.propTypes = {
  refused: PropTypes.arrayOf(
    PropTypes.shape({
      requestLineItemId: PropTypes.string,
      reason: PropTypes.string,
    })
  ).isRequired,
};

export default BulkLotNdcRefusedPanel;
